import ReactDOM from 'react-dom'
import MediaPlayer from './MediaPlayer';

export {default as Header} from './Header'

{/* Dashboard Components */
}
export {default as CustomerSidebar} from './CustomerSidebar'

export {default as FunctionMenu} from './FunctionMenu'
export {default as SecondMenu} from './SecondMenu'


// 播放媒体
export function showMediaPlayer(props = {}) {
  const div = document.createDocumentFragment()
  document.body.appendChild(div);

  function onCancel() {
    ReactDOM.unmountComponentAtNode(div)
    props.onCancel && props.onCancel();
  }
  ReactDOM.render(<MediaPlayer {...props} onCancel={onCancel} />, div)
}